<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';

import Select from "../../components/Select/Select.vue";
import { useOptions } from "../../store/options.store";
import { useUsersStore } from "../../store/users.store";
import { IOptionForm } from '../../models/forms/optionForm';
import { reloadCenterDependentStores, isSwitchingCenter } from '../../helper/storeLoader';

const usersStore = useUsersStore();
const optionsStore = useOptions();


const valueSelected = async (value: number) => {
    if ( value && !isSwitchingCenter.value) {
        updateFavoris(value);
        // Bloquer les watchers des vues pendant la transition
        isSwitchingCenter.value = true;
        // 1. Changer le centre courant
        await usersStore.setCurrentCenter(value);
        // 2. Recharger les stores centre-dépendants (met isSwitchingCenter = false à la fin)
        await reloadCenterDependentStores(value);
    }
}

const currentCenter = computed(() => {
    if (usersStore.currentCenter?.id == undefined)
        return undefined;
    return usersStore.getCentersUserCbItem.find((item) => item.id == usersStore.currentCenter.id);
})


let FavCenter = computed(() => {
    return optionsStore.datas?.filter((item) => item.code == "FAV_CENTER" && item.user == usersStore.currentUser.email);
})

const updateFavoris = async (option:number) => {
    if ( FavCenter.value.length>0) {
        FavCenter.value[0].value = option.toString();
        optionsStore.newForm();
        console.log("Mise à jour favoris : ",FavCenter.value[0]);
        optionsStore.itemForm = await optionsStore.toForm(FavCenter.value[0]);
        console.log("Mise à jour favoris : ",optionsStore.itemForm);
    } else {
        optionsStore.newForm();
        optionsStore.itemForm = {
            code: "FAV_CENTER",
            value: option.toString(),
            user: usersStore.currentUser.email,
            default:true,
        } as IOptionForm;
    }
    await optionsStore.save();
    await usersStore.setCenterFav(option);
}


onMounted(async () => {

})

const logo = computed(() => {
    return "images/societies/" + usersStore.getCurrentSociety?.code3 + (usersStore.getCurrentSociety?.code3 == "GD" ? ".svg" : ".png");
})
</script>

<template>
  <div class="header__right">
        <figure class="header__right-logo">
            <img
                :src="logo"
                :alt="'logo '+usersStore.getCurrentSociety?.value"
                class="header__right-logo-img"
            />
        </figure>
        <!-- Center select -->
        <Select :datas="usersStore.getCentersUserCbItem" :defaultValue="currentCenter"
            id="id" label="label" value="id" displayIcon icon="icon" displayPrefix prefix="icon"
            @selectedValue="valueSelected"
        />
    </div>
</template>
